import { RootState } from "../../reducers";
import { UserDatabaseSummary } from "../../../data/models/userDatabase";

export const userDatabaseSummariesSelector = (
  state: RootState
): UserDatabaseSummary[] =>
  state.user.databaseSummaries.sort(
    (a, b) => -a.date.lastModified.localeCompare(b.date.lastModified)
  );
